import { IApplicationState } from '../../types/redux';

export const isLoadingSelector = (state: IApplicationState): boolean => {
  return state.consultantCianChat.isLoading;
};
